<script setup lang="ts">
import { shallowRef } from 'vue';
import { KeyboardNavigation } from '@hfc/ui-core';

const buttonRefs = shallowRef<Array<HTMLButtonElement>>([]);

const { handleFocus } = KeyboardNavigation(buttonRefs.value);

interface ButtonSetOptions {
  text: string,
  value: string
}

const model = defineModel<string>();

const props = withDefaults(defineProps<{
  questionText?: string,
  id: string,
  options: Array<ButtonSetOptions>,
  autoFocus?: boolean,
  size?: string
}>(), {
  size: 'h-12 md:h-16'
});

const selectOption = (value: string): void => {
  model.value = value;
};

</script>
<template>
  <div class="flex flex-col sm:flex-row sm:items-center">
    <div class="mr-2 mb-4 sm:mb-0 sm:mr-12 sm:w-1/2 md:w-auto" v-if="questionText">
      <span class="text-blue-500 font-medium text-lg">{{ questionText }}</span>
    </div>
    <div class="flex flex-1 items-start flex-col md:flex-row w-full" :class="{ 'justify-end': questionText }">
      <div class="flex" :class="size" tabindex="0" @focus="handleFocus(buttonRefs, props.options, model)" v-autofocus="autoFocus">
        <button v-for="(button, index) in options"
          :key="index"
          type="button"
          tabindex="-1"
          :data-value="button.value"
          @click="selectOption(button.value)"
          :ref="el => buttonRefs.push(el as HTMLButtonElement)"
          class="h-full px-5 first-of-type:rounded-full last-of-type:rounded-full first-of-type:rounded-r-none last-of-type:rounded-l-none mb-2 text-md md:text-xl min-w-[6rem] w-auto border-2 border-blue-300 focus:shadow-inner focus:shadow-gray-300"
          :class="{ 'bg-blue text-white rounded focus:shadow-none focus:border-blue-900': button.value === model, 'focus:border-blue-600': button.value !== model }">
          {{ button.text }}
        </button>
      </div>
    </div>
  </div>
</template>
